import { render } from "./UnitGroup.vue?vue&type=template&id=1c59ad94&scoped=true"
import script from "./UnitGroup.vue?vue&type=script&lang=js"
export * from "./UnitGroup.vue?vue&type=script&lang=js"

import "./UnitGroup.vue?vue&type=style&index=0&id=1c59ad94&lang=scss&scoped=true"

import exportComponent from "C:\\agent\\_work\\860\\s\\ClientApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c59ad94"]])

export default __exports__